import { AxiosError, AxiosResponse } from "axios";
import { OptionsModalEnum, ResponseMessagesEnum } from "../../interfaces/Enums";
import { IPinSchema } from "../../interfaces/IPin";
import { api } from "../../services/api";
import { useAlertError } from "../../store/AlertError";
import { useAuthentication } from "../../store/Authentication";
import { useGlobalLoading } from "../../store/GlobalLoading";
import { useModalStore } from "../../store/ModalStore";
import { useAuthProfile } from "../Auth/profile";

export function usePinPost() {
  const { profile, setProfile } = useAuthentication();
  const { openAlert } = useAlertError();
  const { closeLoading, openLoading } = useGlobalLoading();
  const { openModal } = useModalStore();
  const { request: requestProfile } = useAuthProfile();

  async function request(body: IPinSchema): Promise<void> {
    openLoading();

    try {
      const response = await api.post("/pin/resgatar", body, {});

      requestProfile();
      setProfile({
        ...profile,
        dataFimPrevista: response.data,
      });
      handleResponse(response);
      closeLoading();
    } catch (error: AxiosError | any) {
      handleError(error);
      closeLoading();
    }
  }

  function handleResponse(response: AxiosResponse): void {
    openModal(OptionsModalEnum.ConfirmPinRescue);
    openAlert({
      message: response.data.message || ResponseMessagesEnum.SuccessPin,
      status: "success",
    });
  }

  function handleError(error: AxiosError): void {
    const { response } = error;

    if (response) {
      const { status = 999, data } = response;

      openAlert({
        message: (data as any)?.message,
        status: "error",
      });
    }
  }

  return { request };
}
